// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Passkey page ??? fully scoped, no global selectors */

.passkey-page {
  max-width: 1140px;
  min-height: 100%;
  margin: 40px auto;
}

.passkey-page *,
.passkey-page *::before,
.passkey-page *::after {
  box-sizing: border-box;
}

.passkey-page__crumbs {
  margin-bottom: 18px;
}

.passkey-page__crumbList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #98a2b3;
  font-size: 13px;
  font-weight: 400;
}

.passkey-page__crumbItem--active {
  color: #667085;
}

.passkey-page__crumbSep {
  color: #cbd5e1;
}

.passkey-page__crumbLink {
  border: none;
  background: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.passkey-page__crumbLink:hover {
  color: #f3f3f3;
  text-decoration: underline;
  text-underline-offset: 3px;
}

body.light_theme .passkey-page__crumbLink:hover {
  color: #101828;
}

.passkey-page__header {
  max-width: 860px;
}

.passkey-page__title {
  margin: 0;
  font-size: 34px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #efefef;
}

body.light_theme .passkey-page__title {
  color: #101828;
}

.passkey-page__subtitle {
  margin: 10px 0 0;
  font-size: 14px;
  line-height: 1.55;
  color: #9CA3AF;
  font-weight: 500;
}

.passkey-page__learn {
  color: #ffffff;
  font-weight: 500;
}

body.light_theme .passkey-page__learn {
  color: #101828;
}

.passkey-page__content {
  margin-top: 22px;
  display: grid;
  place-items: center;
  gap: 18px;
  padding: 22px 12px 0;
}

.passkey-page__artWrap {
  width: 282px;
  display: flex;
  justify-content: center;
}

.passkey-page__crumbList li.passkey-page__crumbItem {
  font-size: 15px;
  font-weight: 500;
  color: #8E939C;
}

.passkey-page__crumbList li.passkey-page__crumbItem.passkey-page__crumbItem--active {
  color: #e8e8e8;
}

body.light_theme .passkey-page__crumbList li.passkey-page__crumbItem.passkey-page__crumbItem--active {
  color: #101828;
}

.passkey-page__header {
  max-width: 900px;
  margin-top: 40px;
  padding-left: 0px;
}

.passkey-page__art {
  width: 100%;
  height: auto;
  display: block;
}

.passkey-page__benefits {
  list-style: none;
  padding: 0;
  margin: 6px 0 0;
  width: min(520px, 92vw);
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.passkey-page__benefit {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.passkey-page__benefitIcon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #f1f5f9;
  color: #344054;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.passkey-page__benefitTitle {
  font-size: 18px;
  font-weight: 600;
  color: #e9e9e9;
  letter-spacing: 0px;
}

body.light_theme .passkey-page__benefitTitle {
  color: #101828;
}

.passkey-page__benefitDesc {
  margin-top: 3px;
  font-size: 14px;
  line-height: 1.45;
  font-weight: 400;
  color: #bababa;
}

body.light_theme .passkey-page__benefitDesc {
  color: #4A5565
}

.passkey-page__cta {
  display: block;
  width: min(520px, 92vw);
  height: 46px;
  border: none;
  border-radius: 999px;
  background: #303236;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 18px;
}

.passkey-page__cta:hover {
  opacity: 0.8;
}

/* Modal (Add a Passkey click) */
.passkey-modal-overlay--onTop {
  z-index: 100000031;
}

.passkey-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.20);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  z-index: 100000030;
}

body.light_theme .passkey-modal-overlay {
  background-color: rgb(255 255 255 /20%);
}

.passkey-modal {
  width: 628px;
  max-width: 92vw;
  border-radius: 20px;
  background: rgb(26 26 26 / 40%);
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  padding: 26px 26px 22px;
  position: relative;
  text-align: center;
}

body.light_theme .passkey-modal {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #E1E1E1;
  box-shadow: 0px 20px 60px #00000030;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.passkey-modal__close {
  position: absolute;
  top: 16px;
  right: 18px;
  width: 36px;
  height: 36px;
  z-index: 999;
  border: none;
  background: transparent;
  color: #84888C;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.passkey-modal__close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

body.light_theme .passkey-modal__close {
  color: #111827;
}

body.light_theme .passkey-modal__close:hover {
  background: rgba(17, 24, 39, 0.06);
  color: #111827;
}

.passkey-modal__art {
  width: 206px;
  margin: 6px auto 16px;
}

.passkey-modal__art img {
  display: block;
  width: 100%;
  height: auto;
}

.passkey-modal__title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.45px;
  color: #ffffff;
}

body.light_theme .passkey-modal__title {
  color: #101828;
}

.passkey-modal__subtitle {
  font-weight: 500;
  margin: 10px auto 18px;
  max-width: 520px;
  font-size: 14px;
  line-height: 1.55;
  color: #84888C;
}

body.light_theme .passkey-modal__subtitle {
  color: #6A7282;
}

.passkey-modal__list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 6px 0px 20px;
}

.passkey-modal__item {
  width: 100%;
  height: 50px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #2b2f36;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  cursor: pointer;
}

.passkey-modal__item:hover {
  background: #363a45;
}

body.light_theme .passkey-modal__item {
  border: 1px solid #E4E4E4;
  background: #ffffffc9;
}

body.light_theme .passkey-modal__item:hover {
  background: #f8fafc;
}

.passkey-modal__itemLeft {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.passkey-modal__itemIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.passkey-modal__itemIcon img {
  width: 18px;
  height: 18px;
  display: block;

}

.passkey-modal__itemIcon {
  background-color: #fff;
  border-radius: 5px;
  padding: 2px;
}

.passkey-modal__itemText {
  font-size: 16px;
  letter-spacing: -0.45px;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

body.light_theme .passkey-modal__itemText {
  color: #111827;
}

.passkey-modal__chev {
  font-size: 22px;
  color: #9ca3af;
  line-height: 1;
}

/* Verify Email modal (opened from Google Authenticator item) */
.passkey-verify-modal {
  text-align: left;
  padding: 28px 24px;
}

.passkey-verify-modal__title {
  margin: 0;
  padding-right: 44px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #ffffff;
}

body.light_theme .passkey-verify-modal__title {
  color: #111827;
}

.passkey-verify-modal__subtitle {
  margin: 10px 0 18px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.45;
  color: #cbcbcb;
  max-width: 480px;
}

body.light_theme .passkey-verify-modal__subtitle {
  color: #84888C;
}

.passkey-verify-modal__otpRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-top: 26px;
}

.passkey-verify-modal__otp {
  width: 56px;
  height: 60px;
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #2b2f36;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  outline: none;
}

.passkey-verify-modal__otp:focus {
  border-color: #D1AA67;
}

.passkey-verify-modal__otp:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

body.light_theme .passkey-verify-modal__otp {
  border: 1px solid #EDEEEF;
  background: #EDEEEF;
  color: #111827;
}

body.light_theme .passkey-verify-modal__otp:focus {
  border-color: #111827;
}

.passkey-verify-modal__totpBlock {
  margin: 18px 0 12px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  width: 100%;
}

.passkey-verify-modal__or {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.passkey-verify-modal__orLine {
  flex: 1 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.12);
}

body.light_theme .passkey-verify-modal__orLine {
  background: #e5e7eb;
}

.passkey-verify-modal__orText {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.04em;
  color: #98a2b3;
}

body.light_theme .passkey-verify-modal__orText {
  color: #6b7280;
}

.passkey-verify-modal__totpLabel {
  font-size: 13px;
  font-weight: 500;
  color: #e5e7eb;
  align-self: flex-start;
}

body.light_theme .passkey-verify-modal__totpLabel {
  color: #374151;
}

.passkey-verify-modal__totpInput {
  width: 100%;
  height: 48px;
  margin: 0;
  padding: 10px 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  background: #2b2f36;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 2px;
  text-align: center;
  color: #ffffff;
  outline: none;
}

.passkey-verify-modal__totpInput::placeholder {
  color: rgba(255, 255, 255, 0.35);
  letter-spacing: 0;
}

.passkey-verify-modal__totpInput:focus {
  border-color: #D1AA67;
}

.passkey-verify-modal__totpInput:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

body.light_theme .passkey-verify-modal__totpInput {
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #111827;
}

body.light_theme .passkey-verify-modal__totpInput::placeholder {
  color: #9ca3af;
}

body.light_theme .passkey-verify-modal__totpInput:focus {
  border-color: #111827;
}

.passkey-verify-modal__links {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.passkey-verify-modal__links--totp {
  justify-content: flex-end;
}

.passkey-verify-modal__link {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  color: #D1AA67;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

.passkey-verify-modal__link:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  text-decoration: none;
}

body.light_theme .passkey-verify-modal__link {
  color: #111827;
}

.passkey-verify-modal__link--paste {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
}

.passkey-verify-modal__confirm {
  width: 100%;
  height: 48px;
  margin-top: 18px;
  border: none;
  border-radius: 999px;
  background: #D1AA67;
  color: #101010;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.passkey-verify-modal__confirm:disabled {
  background: #303236;
  color: rgba(255, 255, 255, 0.4);
  cursor: not-allowed;
}

body.light_theme .passkey-verify-modal__confirm {
  background: #303236;
  color: #fff;
  cursor: not-allowed;
}

body.light_theme .passkey-verify-modal__confirm:not(:disabled) {
  cursor: pointer;
}

.passkey-verify-modal__unable {
  width: 100%;
  margin: 0;
  display: block;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  color: #D1AA67;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
  text-align: center;
}

body.light_theme .passkey-verify-modal__unable {
  color: #111827;
}

.passkey-verify-modal__footerRow {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 12px 16px;
  margin-top: 16px;
  width: 100%;
  flex-wrap: wrap;
}

.passkey-verify-modal__footerRow .passkey-verify-modal__chooseOther {
  margin: 0;
}

.passkey-verify-modal__chooseOther {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  color: #D1AA67;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
  text-align: left;
  flex: 0 0 auto;
}

body.light_theme .passkey-verify-modal__chooseOther {
  color: #111827;
}

.passkey-verify-modal__methodPicker {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
  padding-top: 4px;
}

.passkey-verify-modal__methodOption {
  width: 100%;
  text-align: left;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  background: #2b2f36;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
}

.passkey-verify-modal__methodOption:hover {
  background: #363a45;
}

body.light_theme .passkey-verify-modal__methodOption {
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #111827;
}

body.light_theme .passkey-verify-modal__methodOption:hover {
  background: #f9fafb;
}

@media (max-width: 520px) {
  .passkey-verify-modal__otpRow {
    gap: 10px;
  }

  .passkey-verify-modal__otp {
    width: 44px;
    height: 52px;
  }

  .passkey-verify-modal__totpInput {
    font-size: 13px;
    height: 44px;
  }
}

@media (max-width: 520px) {
  .passkey-page {
    padding: 22px 16px 44px;
  }

  .passkey-page__title {
    font-size: 28px;
  }

  .passkey-modal {
    padding: 20px 16px 16px;
  }
}



/* ============================================================================
 * Passkey Manage / Delete view ? when user already has passkey(s)
 * ========================================================================== */

.passkey-page__manage {
  margin-top: 28px;
  padding: 24px;
  background: #ffffff14;
  border: 1px solid #eaecef14;
  border-radius: 16px;
  max-width: 900px;
  color: #fff;
}

body.light_theme .passkey-page__manage {
  background: #fff;
  border: 1px solid #eaecef;
  color: #1a1a1a;
}

.passkey-page__manageHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.passkey-page__manageTitle {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.passkey-page__addMore {
  background: #101828;
  color: #ffffff;
  border: 0;
  border-radius: 999px;
  padding: 11px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}

/* .passkey-page__addMore:hover {
  background: #c19b2a;
} */

.passkey-page__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.passkey-page__listItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border: 1px solid #eaecef14;
  border-radius: 10px;
  background: #fafbfc14;
}

body.light_theme .passkey-page__listItem {
  border: 1px solid #eaecef;
  background: #fafbfc;
}

.passkey-page__listMain {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.passkey-page__listIcon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #00c853 0%, #00a844 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.passkey-page__listBody {
  min-width: 0;
}

.passkey-page__listName {
  font-size: 14px;
  font-weight: 600;
  color: #efefef;
  margin: 0 0 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

body.light_theme .passkey-page__listName {
  color: #101828;
}

.passkey-page__listMeta {
  font-size: 11px;
  color: #cdcdcd;
  line-height: 1.4;
}

body.light_theme .passkey-page__listMeta {
  color: #667085;
}

.passkey-page__delete {
  background: transparent;
  color: #dc3545;
  border: 1px solid #f1c4c8;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.passkey-page__delete:hover {
  background: #fdecee;
}

.passkey-page__delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.passkey-page__empty {
  text-align: center;
  padding: 30px 0;
  color: #667085;
  font-size: 13px;
}

/* Confirmation buttons styling inside the existing modal */
.passkey-modal__danger {
  background: #dc3545;
  color: #fff;
  border: 0;
  border-radius: 999px;
  padding: 12px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  margin-top: 12px;
}

.passkey-modal__danger:hover {
  background: #c82333;
}

.passkey-modal__danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.passkey-modal__cancel {
  background: transparent;
  color: #667085;
  border: 0;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 8px;
}

.passkey-modal__cancel:hover {
  color: #e7e7e7;
}

body.light_theme .passkey-modal__cancel:hover {
  color: #101828;
}


@media (max-width: 1440px) {

  .passkey-page {
    padding: 0px 20px;
  }


}

@media (max-width: 1200px) {

  .passkey-page__title {
    font-size: 30px;
  }

}

@media (max-width: 767px) {

  .passkey-page__title {
    font-size: 24px;
  }

  .passkey-page__content {
    margin-top: 0px;
    padding: 22px 0px 0;
  }

  .passkey-page__benefitTitle {
    font-size: 16px;
  }

  .passkey-page__cta {
    height: 42px;
    font-size: 15px;
    margin-top: 15px;
  }

  .passkey-modal {
    width: 100%;
    max-height: 70vh;
    overflow: auto;
    min-height: 40vh;
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
  }

  .passkey-modal-overlay {
    padding: 0px;
    align-items: end;
  }

  .passkey-verify-modal__title {
    font-size: 20px;
  }

  .passkey-verify-modal__otp {
    font-size: 16px;
  }

  .passkey-verify-modal__confirm {
    height: 42px;
    font-size: 14px;
  }

  .passkey-modal__art {
    width: 150px;
  }

  .passkey-modal__title {
    font-size: 20px;
  }

  .passkey-page__header {
    margin-top: 30px;
  }

  .passkey-page__manage {
    margin-top: 15px;
    padding: 18px;
    border-radius: 12px;
  }

  .passkey-page__listItem {
    gap: 10px;
  }



}

/* Login — passkey step uses same modal shell as Security / Passkey pages */
.passkey-modal-overlay.passkey-modal-overlay--loginPasskey {
  align-items: center;
  justify-content: center;
  padding: 18px;
}

.passkey-modal.passkey-modal--loginPasskey {
  width: min(539px, 92vw);
  max-width: 539px;
  padding: 32px 26px 26px;
}


.passkey-modal--loginPasskey .passkey-modal__subtitle {
  margin-bottom: 14px;
}

.passkey-modal__fingerprintRing {
  width: 214px;
  margin: 6px auto 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.passkey-modal__fingerprintRing .ri-fingerprint-line {
  font-size: 44px;
  color: #ffffff;
  line-height: 1;
}

.passkey-modal__hintLine {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 500;
  color: #6a7282;
  line-height: 1.45;
}

.passkey-modal__hintLine--muted {
  margin-bottom: 22px;
  font-size: 13px;
  font-weight: 400;
  color: #84888c;
}

.passkey-modal__loginPrimaryBtn {
  width: 100%;
  height: 48px;
  margin: 12px 0 18px;
  border: none;
  border-radius: 999px;
  background: #303236;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  cursor: pointer;
}

.passkey-modal__loginPrimaryBtn:hover:not(:disabled) {
  background: #1a1b1f;
}

.passkey-modal__loginPrimaryBtn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.passkey-modal__loginSwitchLink {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0 auto;
  text-align: center;
}

@media (max-width: 767px) {

  .passkey-modal.passkey-modal--loginPasskey {
    padding: 32px 26px 38px;
  }

  body .passkey-modal--loginPasskey .passkey-modal__subtitle {
    font-size: 14px;
  }


  .passkey-modal-overlay.passkey-modal-overlay--loginPasskey {
    align-items: end;
    padding: 0px;
  }


  .passkey-page__addMore {
    padding: 8px 15px;
    font-size: 12px;
  }

  .passkey-modal.passkey-modal--loginPasskey {
    border-radius: 20px 20px 0px 0px;
    width: 100%;
    max-width: 100%;
  }

  body.loginbg .form_block_login h2,
  body.signupbg .form_block_login h2 {
    font-size: 22px;
  }


  .passkey-page__artWrap {
    width: 200px;
  }

}

@media (max-width: 480px) {

  .passkey-page__title {
    font-size: 22px;
  }

  .passkey-page__manageTitle {
    font-size: 16px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/PasskeyPage/passkey.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;EAC3C,4CAA4C;EAC5C,0BAA0B;EAC1B,kCAAkC;EAClC,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,mCAAmC;EACnC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;;AAEhB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;AACF;;;;AAIA;;+EAE+E;;AAE/E;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;;EAEE;IACE,iBAAiB;EACnB;;;AAGF;;AAEA;;EAEE;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;;;AAIF;;AAEA,2EAA2E;AAC3E;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,gBAAgB;IAChB,YAAY;EACd;;;EAGA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gCAAgC;IAChC,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;;EAGA;IACE,YAAY;EACd;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["/* Passkey page ??? fully scoped, no global selectors */\n\n.passkey-page {\n  max-width: 1140px;\n  min-height: 100%;\n  margin: 40px auto;\n}\n\n.passkey-page *,\n.passkey-page *::before,\n.passkey-page *::after {\n  box-sizing: border-box;\n}\n\n.passkey-page__crumbs {\n  margin-bottom: 18px;\n}\n\n.passkey-page__crumbList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #98a2b3;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.passkey-page__crumbItem--active {\n  color: #667085;\n}\n\n.passkey-page__crumbSep {\n  color: #cbd5e1;\n}\n\n.passkey-page__crumbLink {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.passkey-page__crumbLink:hover {\n  color: #f3f3f3;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\nbody.light_theme .passkey-page__crumbLink:hover {\n  color: #101828;\n}\n\n.passkey-page__header {\n  max-width: 860px;\n}\n\n.passkey-page__title {\n  margin: 0;\n  font-size: 34px;\n  font-weight: 600;\n  letter-spacing: 0px;\n  color: #efefef;\n}\n\nbody.light_theme .passkey-page__title {\n  color: #101828;\n}\n\n.passkey-page__subtitle {\n  margin: 10px 0 0;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #9CA3AF;\n  font-weight: 500;\n}\n\n.passkey-page__learn {\n  color: #ffffff;\n  font-weight: 500;\n}\n\nbody.light_theme .passkey-page__learn {\n  color: #101828;\n}\n\n.passkey-page__content {\n  margin-top: 22px;\n  display: grid;\n  place-items: center;\n  gap: 18px;\n  padding: 22px 12px 0;\n}\n\n.passkey-page__artWrap {\n  width: 282px;\n  display: flex;\n  justify-content: center;\n}\n\n.passkey-page__crumbList li.passkey-page__crumbItem {\n  font-size: 15px;\n  font-weight: 500;\n  color: #8E939C;\n}\n\n.passkey-page__crumbList li.passkey-page__crumbItem.passkey-page__crumbItem--active {\n  color: #e8e8e8;\n}\n\nbody.light_theme .passkey-page__crumbList li.passkey-page__crumbItem.passkey-page__crumbItem--active {\n  color: #101828;\n}\n\n.passkey-page__header {\n  max-width: 900px;\n  margin-top: 40px;\n  padding-left: 0px;\n}\n\n.passkey-page__art {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.passkey-page__benefits {\n  list-style: none;\n  padding: 0;\n  margin: 6px 0 0;\n  width: min(520px, 92vw);\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.passkey-page__benefit {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.passkey-page__benefitIcon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  background: #f1f5f9;\n  color: #344054;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n}\n\n.passkey-page__benefitTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #e9e9e9;\n  letter-spacing: 0px;\n}\n\nbody.light_theme .passkey-page__benefitTitle {\n  color: #101828;\n}\n\n.passkey-page__benefitDesc {\n  margin-top: 3px;\n  font-size: 14px;\n  line-height: 1.45;\n  font-weight: 400;\n  color: #bababa;\n}\n\nbody.light_theme .passkey-page__benefitDesc {\n  color: #4A5565\n}\n\n.passkey-page__cta {\n  display: block;\n  width: min(520px, 92vw);\n  height: 46px;\n  border: none;\n  border-radius: 999px;\n  background: #303236;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 500;\n  cursor: pointer;\n  margin-top: 18px;\n}\n\n.passkey-page__cta:hover {\n  opacity: 0.8;\n}\n\n/* Modal (Add a Passkey click) */\n.passkey-modal-overlay--onTop {\n  z-index: 100000031;\n}\n\n.passkey-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.20);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n  z-index: 100000030;\n}\n\nbody.light_theme .passkey-modal-overlay {\n  background-color: rgb(255 255 255 /20%);\n}\n\n.passkey-modal {\n  width: 628px;\n  max-width: 92vw;\n  border-radius: 20px;\n  background: rgb(26 26 26 / 40%);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  padding: 26px 26px 22px;\n  position: relative;\n  text-align: center;\n}\n\nbody.light_theme .passkey-modal {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #E1E1E1;\n  box-shadow: 0px 20px 60px #00000030;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.passkey-modal__close {\n  position: absolute;\n  top: 16px;\n  right: 18px;\n  width: 36px;\n  height: 36px;\n  z-index: 999;\n  border: none;\n  background: transparent;\n  color: #84888C;\n  font-size: 26px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n  transition: all 0.2s ease;\n}\n\n.passkey-modal__close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\nbody.light_theme .passkey-modal__close {\n  color: #111827;\n}\n\nbody.light_theme .passkey-modal__close:hover {\n  background: rgba(17, 24, 39, 0.06);\n  color: #111827;\n}\n\n.passkey-modal__art {\n  width: 206px;\n  margin: 6px auto 16px;\n}\n\n.passkey-modal__art img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.passkey-modal__title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.45px;\n  color: #ffffff;\n}\n\nbody.light_theme .passkey-modal__title {\n  color: #101828;\n}\n\n.passkey-modal__subtitle {\n  font-weight: 500;\n  margin: 10px auto 18px;\n  max-width: 520px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #84888C;\n}\n\nbody.light_theme .passkey-modal__subtitle {\n  color: #6A7282;\n}\n\n.passkey-modal__list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin: 6px 0px 20px;\n}\n\n.passkey-modal__item {\n  width: 100%;\n  height: 50px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: #2b2f36;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  cursor: pointer;\n}\n\n.passkey-modal__item:hover {\n  background: #363a45;\n}\n\nbody.light_theme .passkey-modal__item {\n  border: 1px solid #E4E4E4;\n  background: #ffffffc9;\n}\n\nbody.light_theme .passkey-modal__item:hover {\n  background: #f8fafc;\n}\n\n.passkey-modal__itemLeft {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.passkey-modal__itemIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.passkey-modal__itemIcon img {\n  width: 18px;\n  height: 18px;\n  display: block;\n\n}\n\n.passkey-modal__itemIcon {\n  background-color: #fff;\n  border-radius: 5px;\n  padding: 2px;\n}\n\n.passkey-modal__itemText {\n  font-size: 16px;\n  letter-spacing: -0.45px;\n  font-weight: 500;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nbody.light_theme .passkey-modal__itemText {\n  color: #111827;\n}\n\n.passkey-modal__chev {\n  font-size: 22px;\n  color: #9ca3af;\n  line-height: 1;\n}\n\n/* Verify Email modal (opened from Google Authenticator item) */\n.passkey-verify-modal {\n  text-align: left;\n  padding: 28px 24px;\n}\n\n.passkey-verify-modal__title {\n  margin: 0;\n  padding-right: 44px;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n}\n\nbody.light_theme .passkey-verify-modal__title {\n  color: #111827;\n}\n\n.passkey-verify-modal__subtitle {\n  margin: 10px 0 18px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.45;\n  color: #cbcbcb;\n  max-width: 480px;\n}\n\nbody.light_theme .passkey-verify-modal__subtitle {\n  color: #84888C;\n}\n\n.passkey-verify-modal__otpRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  margin-top: 26px;\n}\n\n.passkey-verify-modal__otp {\n  width: 56px;\n  height: 60px;\n  border-radius: 7px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: #2b2f36;\n  text-align: center;\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n  outline: none;\n}\n\n.passkey-verify-modal__otp:focus {\n  border-color: #D1AA67;\n}\n\n.passkey-verify-modal__otp:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\nbody.light_theme .passkey-verify-modal__otp {\n  border: 1px solid #EDEEEF;\n  background: #EDEEEF;\n  color: #111827;\n}\n\nbody.light_theme .passkey-verify-modal__otp:focus {\n  border-color: #111827;\n}\n\n.passkey-verify-modal__totpBlock {\n  margin: 18px 0 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 10px;\n  width: 100%;\n}\n\n.passkey-verify-modal__or {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.passkey-verify-modal__orLine {\n  flex: 1;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.12);\n}\n\nbody.light_theme .passkey-verify-modal__orLine {\n  background: #e5e7eb;\n}\n\n.passkey-verify-modal__orText {\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.04em;\n  color: #98a2b3;\n}\n\nbody.light_theme .passkey-verify-modal__orText {\n  color: #6b7280;\n}\n\n.passkey-verify-modal__totpLabel {\n  font-size: 13px;\n  font-weight: 500;\n  color: #e5e7eb;\n  align-self: flex-start;\n}\n\nbody.light_theme .passkey-verify-modal__totpLabel {\n  color: #374151;\n}\n\n.passkey-verify-modal__totpInput {\n  width: 100%;\n  height: 48px;\n  margin: 0;\n  padding: 10px 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  background: #2b2f36;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 2px;\n  text-align: center;\n  color: #ffffff;\n  outline: none;\n}\n\n.passkey-verify-modal__totpInput::placeholder {\n  color: rgba(255, 255, 255, 0.35);\n  letter-spacing: 0;\n}\n\n.passkey-verify-modal__totpInput:focus {\n  border-color: #D1AA67;\n}\n\n.passkey-verify-modal__totpInput:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\nbody.light_theme .passkey-verify-modal__totpInput {\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  color: #111827;\n}\n\nbody.light_theme .passkey-verify-modal__totpInput::placeholder {\n  color: #9ca3af;\n}\n\nbody.light_theme .passkey-verify-modal__totpInput:focus {\n  border-color: #111827;\n}\n\n.passkey-verify-modal__links {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.passkey-verify-modal__links--totp {\n  justify-content: flex-end;\n}\n\n.passkey-verify-modal__link {\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #D1AA67;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  cursor: pointer;\n}\n\n.passkey-verify-modal__link:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  text-decoration: none;\n}\n\nbody.light_theme .passkey-verify-modal__link {\n  color: #111827;\n}\n\n.passkey-verify-modal__link--paste {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  text-decoration: none;\n}\n\n.passkey-verify-modal__confirm {\n  width: 100%;\n  height: 48px;\n  margin-top: 18px;\n  border: none;\n  border-radius: 999px;\n  background: #D1AA67;\n  color: #101010;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.passkey-verify-modal__confirm:disabled {\n  background: #303236;\n  color: rgba(255, 255, 255, 0.4);\n  cursor: not-allowed;\n}\n\nbody.light_theme .passkey-verify-modal__confirm {\n  background: #303236;\n  color: #fff;\n  cursor: not-allowed;\n}\n\nbody.light_theme .passkey-verify-modal__confirm:not(:disabled) {\n  cursor: pointer;\n}\n\n.passkey-verify-modal__unable {\n  width: 100%;\n  margin: 0;\n  display: block;\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #D1AA67;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  text-align: center;\n}\n\nbody.light_theme .passkey-verify-modal__unable {\n  color: #111827;\n}\n\n.passkey-verify-modal__footerRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 12px 16px;\n  margin-top: 16px;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.passkey-verify-modal__footerRow .passkey-verify-modal__chooseOther {\n  margin: 0;\n}\n\n.passkey-verify-modal__chooseOther {\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #D1AA67;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  text-align: left;\n  flex: 0 0 auto;\n}\n\nbody.light_theme .passkey-verify-modal__chooseOther {\n  color: #111827;\n}\n\n.passkey-verify-modal__methodPicker {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 10px;\n  padding-top: 4px;\n}\n\n.passkey-verify-modal__methodOption {\n  width: 100%;\n  text-align: left;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  background: #2b2f36;\n  padding: 10px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.passkey-verify-modal__methodOption:hover {\n  background: #363a45;\n}\n\nbody.light_theme .passkey-verify-modal__methodOption {\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  color: #111827;\n}\n\nbody.light_theme .passkey-verify-modal__methodOption:hover {\n  background: #f9fafb;\n}\n\n@media (max-width: 520px) {\n  .passkey-verify-modal__otpRow {\n    gap: 10px;\n  }\n\n  .passkey-verify-modal__otp {\n    width: 44px;\n    height: 52px;\n  }\n\n  .passkey-verify-modal__totpInput {\n    font-size: 13px;\n    height: 44px;\n  }\n}\n\n@media (max-width: 520px) {\n  .passkey-page {\n    padding: 22px 16px 44px;\n  }\n\n  .passkey-page__title {\n    font-size: 28px;\n  }\n\n  .passkey-modal {\n    padding: 20px 16px 16px;\n  }\n}\n\n\n\n/* ============================================================================\n * Passkey Manage / Delete view ? when user already has passkey(s)\n * ========================================================================== */\n\n.passkey-page__manage {\n  margin-top: 28px;\n  padding: 24px;\n  background: #ffffff14;\n  border: 1px solid #eaecef14;\n  border-radius: 16px;\n  max-width: 900px;\n  color: #fff;\n}\n\nbody.light_theme .passkey-page__manage {\n  background: #fff;\n  border: 1px solid #eaecef;\n  color: #1a1a1a;\n}\n\n.passkey-page__manageHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.passkey-page__manageTitle {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.passkey-page__addMore {\n  background: #101828;\n  color: #ffffff;\n  border: 0;\n  border-radius: 999px;\n  padding: 11px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n/* .passkey-page__addMore:hover {\n  background: #c19b2a;\n} */\n\n.passkey-page__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.passkey-page__listItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 16px;\n  border: 1px solid #eaecef14;\n  border-radius: 10px;\n  background: #fafbfc14;\n}\n\nbody.light_theme .passkey-page__listItem {\n  border: 1px solid #eaecef;\n  background: #fafbfc;\n}\n\n.passkey-page__listMain {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n}\n\n.passkey-page__listIcon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #00c853 0%, #00a844 100%);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.passkey-page__listBody {\n  min-width: 0;\n}\n\n.passkey-page__listName {\n  font-size: 14px;\n  font-weight: 600;\n  color: #efefef;\n  margin: 0 0 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nbody.light_theme .passkey-page__listName {\n  color: #101828;\n}\n\n.passkey-page__listMeta {\n  font-size: 11px;\n  color: #cdcdcd;\n  line-height: 1.4;\n}\n\nbody.light_theme .passkey-page__listMeta {\n  color: #667085;\n}\n\n.passkey-page__delete {\n  background: transparent;\n  color: #dc3545;\n  border: 1px solid #f1c4c8;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.passkey-page__delete:hover {\n  background: #fdecee;\n}\n\n.passkey-page__delete:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.passkey-page__empty {\n  text-align: center;\n  padding: 30px 0;\n  color: #667085;\n  font-size: 13px;\n}\n\n/* Confirmation buttons styling inside the existing modal */\n.passkey-modal__danger {\n  background: #dc3545;\n  color: #fff;\n  border: 0;\n  border-radius: 999px;\n  padding: 12px 22px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  width: 100%;\n  margin-top: 12px;\n}\n\n.passkey-modal__danger:hover {\n  background: #c82333;\n}\n\n.passkey-modal__danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.passkey-modal__cancel {\n  background: transparent;\n  color: #667085;\n  border: 0;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  margin-top: 8px;\n}\n\n.passkey-modal__cancel:hover {\n  color: #e7e7e7;\n}\n\nbody.light_theme .passkey-modal__cancel:hover {\n  color: #101828;\n}\n\n\n@media (max-width: 1440px) {\n\n  .passkey-page {\n    padding: 0px 20px;\n  }\n\n\n}\n\n@media (max-width: 1200px) {\n\n  .passkey-page__title {\n    font-size: 30px;\n  }\n\n}\n\n@media (max-width: 767px) {\n\n  .passkey-page__title {\n    font-size: 24px;\n  }\n\n  .passkey-page__content {\n    margin-top: 0px;\n    padding: 22px 0px 0;\n  }\n\n  .passkey-page__benefitTitle {\n    font-size: 16px;\n  }\n\n  .passkey-page__cta {\n    height: 42px;\n    font-size: 15px;\n    margin-top: 15px;\n  }\n\n  .passkey-modal {\n    width: 100%;\n    max-height: 70vh;\n    overflow: auto;\n    min-height: 40vh;\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .passkey-modal-overlay {\n    padding: 0px;\n    align-items: end;\n  }\n\n  .passkey-verify-modal__title {\n    font-size: 20px;\n  }\n\n  .passkey-verify-modal__otp {\n    font-size: 16px;\n  }\n\n  .passkey-verify-modal__confirm {\n    height: 42px;\n    font-size: 14px;\n  }\n\n  .passkey-modal__art {\n    width: 150px;\n  }\n\n  .passkey-modal__title {\n    font-size: 20px;\n  }\n\n  .passkey-page__header {\n    margin-top: 30px;\n  }\n\n  .passkey-page__manage {\n    margin-top: 15px;\n    padding: 18px;\n    border-radius: 12px;\n  }\n\n  .passkey-page__listItem {\n    gap: 10px;\n  }\n\n\n\n}\n\n/* Login — passkey step uses same modal shell as Security / Passkey pages */\n.passkey-modal-overlay.passkey-modal-overlay--loginPasskey {\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n}\n\n.passkey-modal.passkey-modal--loginPasskey {\n  width: min(539px, 92vw);\n  max-width: 539px;\n  padding: 32px 26px 26px;\n}\n\n\n.passkey-modal--loginPasskey .passkey-modal__subtitle {\n  margin-bottom: 14px;\n}\n\n.passkey-modal__fingerprintRing {\n  width: 214px;\n  margin: 6px auto 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.passkey-modal__fingerprintRing .ri-fingerprint-line {\n  font-size: 44px;\n  color: #ffffff;\n  line-height: 1;\n}\n\n.passkey-modal__hintLine {\n  margin: 0 0 6px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6a7282;\n  line-height: 1.45;\n}\n\n.passkey-modal__hintLine--muted {\n  margin-bottom: 22px;\n  font-size: 13px;\n  font-weight: 400;\n  color: #84888c;\n}\n\n.passkey-modal__loginPrimaryBtn {\n  width: 100%;\n  height: 48px;\n  margin: 12px 0 18px;\n  border: none;\n  border-radius: 999px;\n  background: #303236;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 400;\n  cursor: pointer;\n}\n\n.passkey-modal__loginPrimaryBtn:hover:not(:disabled) {\n  background: #1a1b1f;\n}\n\n.passkey-modal__loginPrimaryBtn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.passkey-modal__loginSwitchLink {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n@media (max-width: 767px) {\n\n  .passkey-modal.passkey-modal--loginPasskey {\n    padding: 32px 26px 38px;\n  }\n\n  body .passkey-modal--loginPasskey .passkey-modal__subtitle {\n    font-size: 14px;\n  }\n\n\n  .passkey-modal-overlay.passkey-modal-overlay--loginPasskey {\n    align-items: end;\n    padding: 0px;\n  }\n\n\n  .passkey-page__addMore {\n    padding: 8px 15px;\n    font-size: 12px;\n  }\n\n  .passkey-modal.passkey-modal--loginPasskey {\n    border-radius: 20px 20px 0px 0px;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  body.loginbg .form_block_login h2,\n  body.signupbg .form_block_login h2 {\n    font-size: 22px;\n  }\n\n\n  .passkey-page__artWrap {\n    width: 200px;\n  }\n\n}\n\n@media (max-width: 480px) {\n\n  .passkey-page__title {\n    font-size: 22px;\n  }\n\n  .passkey-page__manageTitle {\n    font-size: 16px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
